import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellGradientsSizeM from './IconWellGradients_size_m';

const props: CreateIconArguments = {
  l: IconWellGradientsSizeM,
  m: IconWellGradientsSizeM,
  s: IconWellGradientsSizeM,
  xs: IconWellGradientsSizeM,
  name: 'IconWellGradients',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
